import React, { useState, useEffect, useMemo, useCallback } from "react";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { Link, useHistory } from "react-router-dom";
import {
  checkDiscount,
  getCurrent,
  GetShoppingCartFinal,
  sendToIdPayPostApi,
} from "../../Api/BarestServices";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import { separate } from "../../Seprate/Seprate";
import { errorToast, succToast } from "../../Toast/Toast";
import Style from "./FinalizePurchase.module.css";
import { Checkbox, Radio } from "antd";

const PriceRow = ({ label, value }) => (
  <div className={Style.totalHolder}>
    <h3 className={Style.priceValue}>
      {separate(value)} <span>تومان</span>
    </h3>
    <h3 className={Style.total}> : {label}</h3>
  </div>
);

const FinalizePurchase = () => {
  const [dataCart, setDataCart] = useState([]);
  const [deliverPrice, setDeliverPrice] = useState({});
  const [freeshippingState, setFreeShippingState] = useState(false);
  const [newPrice, setNewPrice] = useState(0);
  const [currentLocations, setCurrentLocations] = useState(null);

  const [loading, setLoading] = useState(false);
  const [getDoor, setGetDoor] = useState(true);
  const [walletState, setWalletState] = useState(false);
  const [disablePay, setDisablePay] = useState(false);
  const [termsState, setTermsState] = useState(false);
  const [code, setCode] = useState("");
  const [value, setValue] = useState("pgw");

  const { register, handleSubmit } = useForm();
  const history = useHistory();

  // ------------------- API Calls -------------------
  useEffect(() => {
    fetchFinalCart();
    fetchCurrentAddress();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchFinalCart = useCallback(async () => {
    GetShoppingCartFinal((succ, res) => {
      if (!succ) return console.error(res);

      if (res.status === 0) {
        errorToast(res.message || "مشکلی پیش آمده است");
        setTimeout(() => history.push("/shopp"), 500);
        return;
      }
      setDataCart(res.cart || []);
      setDeliverPrice(res.delivery_price || {});
    });
  }, [history]);

  const fetchCurrentAddress = useCallback(() => {
    getCurrent((succ, res) => {
      if (succ && res.status !== 0) {
        setCurrentLocations(res.address);
      } else {
        errorToast("مشکلی در دریافت آدرس پیش آمده است");
      }
    });
  }, []);

  // ------------------- Discount -------------------
  const onSubmitHandler = (data) => {
    setCode(data.code);
    checkDiscount({ code: data.code }, (res) => {
      if (res.status === 0) {
        errorToast(res.message);
        setCode("");
      } else {
        succToast("تخفیف با موفقیت اعمال شد");
        setNewPrice(res.total);
        setFreeShippingState(res.free_shipping);
      }
    });
  };

  // ------------------- Payment -------------------
  const sendToIdPay = () => {
    if (!value) {
      return errorToast("ابتدا درگاه موردنظر را مشخص کنید");
    }
    if (!termsState) {
      return errorToast("شرایط و قوانین را مطالعه کرده و تایید کنید");
    }

    setDisablePay(true);
    setLoading(true);

    const info = {
      code,
      where_to_deliver: getDoor ? "in" : "out",
      delivery_price: getDoor ? deliverPrice.in : deliverPrice.out,
      wallet: walletState,
      payment_type: value,
    };

    sendToIdPayPostApi(info, (res) => {
      setDisablePay(false);
      setLoading(false);

      if (res.status === 1) {
        window.open(res.link, "_self");
      } else {
        errorToast(res.message);
      }
    });
  };

  // ------------------- Calculations -------------------
  const totalPrice = useMemo(
    () => dataCart.reduce((acc, cur) => acc + parseInt(cur.total || 0), 0),
    [dataCart]
  );

const deliveryCost = useMemo(() => {
  if (freeshippingState) return 0;
  return getDoor ? deliverPrice?.in || 0 : deliverPrice?.out || 0;
}, [freeshippingState, deliverPrice, getDoor]);

const finalPrice = useMemo(() => {
  const base = newPrice > 0 ? newPrice : totalPrice;
  return base + deliveryCost;
}, [newPrice, totalPrice, deliveryCost]);

  // ------------------- Render -------------------
  if (!dataCart.length) {
    return (
      <section className={Style.componentHolder}>
        <BurgerMenuTitle title="سفارش نهایی" />
        <PointSpreadLoading color="#ab0c59" size="small" style={{ margin: "8rem 0" }} />
      </section>
    );
  }

  return (
    <section className={Style.pageHolder}>
      <BurgerMenuTitle title="سفارش نهایی" />
      {loading ? (
        <div className={Style.loading}>
          <PointSpreadLoading color="#ab0c59" size="small" />
        </div>
      ) : (
        <div className={Style.listHolder}>
          {/* Address */}
          {currentLocations && (
            <div className={Style.currentAddress}>
              <h2 className={Style.addressPart}>
                <FontAwesomeIcon icon={faMapMarkerAlt} className={Style.markerIcon} />
                {`شهر: ${currentLocations.city}, 
                  روستا: ${currentLocations.region}, 
                  خیابان: ${currentLocations.street}, 
                  کوچه: ${currentLocations.alley}, 
                  ساختمان: ${currentLocations.apartment_name}, 
                  واحد: ${currentLocations.apartment_number}, 
                  پلاک: ${currentLocations.plate}, 
                  ${currentLocations.description}`}
              </h2>
              <Link to="/changeaddress" className={Style.changeLink}>
                <h2 className={Style.change}>تغییر آدرس</h2>
              </Link>
            </div>
          )}

          {/* Cart Items */}
          {dataCart.map((item, idx) => (
            <div key={idx} className={Style.holderBuy}>
              <div className={Style.logoHolder}>
                <img src={`//cdn.barest.ir/supplier/logo/${item.logo}.jpg`} alt="رستوران" />
              </div>
              <div className={Style.NameHolder}>
                <h3>سبدخرید {idx + 1}:</h3>
                <p>{item.name}</p>
                <span className={Style.spanBuy}>{separate(item.total)} تومان</span>
              </div>
            </div>
          ))}

          {/* Options */}
          <div className={Style.liftHolder}>
            <input
              className={Style.checkInput}
              type="checkbox"
              checked={getDoor}
              onChange={(e) => setGetDoor(e.target.checked)}
              id="doorReceive"
            />
            <label htmlFor="doorReceive">درب منزل تحویل می‌گیرم</label>
          </div>

          {localStorage.getItem("wallet") !== "0" && (
            <div className={Style.liftHolder}>
              <input
                className={Style.checkInput}
                type="checkbox"
                checked={walletState}
                onChange={(e) => setWalletState(e.target.checked)}
                id="wallet"
              />
              <label htmlFor="wallet">
                برداشت از کیف پول{" "}
                <p>({separate(localStorage.getItem("wallet"))} تومان)</p>
              </label>
            </div>
          )}

          <div className={Style.payPart}>
            {/* Discount */}
          <form onSubmit={handleSubmit(onSubmitHandler)} className={Style.discount}>
            <button className={Style.btnDiscount} type="submit">
              اعمال
            </button>
            <input
              {...register("code")}
              className={Style.inputHolder}
              type="text"
              placeholder="کدتخفیف"
            />
          </form>

          {/* Price Summary */}
          <PriceRow label="مبلغ کل خرید" value={totalPrice} />
          <PriceRow label="مبلغ با تخفیف" value={newPrice > 0 ? newPrice : totalPrice} />
          <PriceRow label="هزینه پیک" value={deliveryCost} />
          <PriceRow label="مبلغ نهایی" value={finalPrice} />

          {/* Payment Method */}
          <Radio.Group onChange={(e) => setValue(e.target.value)} value={value} className={Style.howPay}>
            <Radio value="pgw">
              <div className={Style.PayTypeHolder}>
                <img
                  src="https://www.parsian-bank.ir/parameters/persian/modules/cdk/upload/content/general_content/244/32448E91-EDDB-4FB5-B996-0D2721CA272B__sis__ParsianBank-Logo.jpg"
                  alt="بانک پارسیان"
                />
                <p>بانک پارسیان</p>
              </div>
            </Radio>
            <Radio value="sadad">
              <div className={Style.PayTypeHolder}>
                <img
                  src="https://bayanbox.ir/view/505036785895245044/logo-bank-melli.jpg"
                  alt="بانک ملی"
                  style={{ objectFit: "contain" }}
                />
                <p>بانک ملی ایران</p>
              </div>
            </Radio>
          </Radio.Group>

          <Checkbox
            style={{ direction: "rtl", width: "100%" }}
            onChange={(e) => setTermsState(e.target.checked)}
          >
            <Link to="/terms">شرایط و قوانین</Link> را مطالعه کرده و قبول می‌کنم!
          </Checkbox>

          <div className={Style.btnHolder}>
            <button className={Style.btnPay} disabled={disablePay} onClick={sendToIdPay}>
              پرداخت
            </button>
          </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default FinalizePurchase;
